import { cancel, createPromise, delaySound, WaiterWith } from "common/promises";
import { speakingName, spritesDurations } from "./resources/sound";
export async function run({ elements: { message, button }, sound, pixiContext, }) {
    const ticker = pixiContext.ticker;
    ticker.speed = 1;
    const buttonFromKeyboard = cancel.root(async (canceler) => {
        while (true) {
            const keyUp = new WaiterWith();
            const onkeyup = (e) => {
                keyUp.trigger(e.key);
            };
            // need event clean up in mobile.
            $(document).one("keyup", onkeyup);
            const key = await keyUp.wait();
            canceler.check();
            if (key === " ") {
                await button.onDown();
            }
        }
    });
    const { resolve, promise } = await createPromise();
    let count = 0;
    let playing = false;
    button.callback = async () => {
        if (playing) {
            return;
        }
        if (count >= 5) {
            return;
        }
        if (message.isScrolling()) {
            return;
        }
        playing = true;
        sound.play(speakingName(count + 1));
        let duration = spritesDurations[speakingName(count + 1)];
        if (count + 1 === 5) {
            duration -= 3000;
        }
        const soundPlay = delaySound(duration);
        const scrollAnimation = message.scroll();
        await Promise.all([soundPlay, scrollAnimation]);
        count += 1;
        if (count == 5) {
            resolve();
        }
        playing = false;
    };
    await promise;
    buttonFromKeyboard.canceler.cancel();
    button.disable();
    await button.dispose();
    // await pixiContext.fadeOut({ durationMS: 1000, sprite: button.sprite });
    // await pixiContext.delay(1000);
}
//# sourceMappingURL=typeInteraction.js.map